import * as React from 'react';
import * as Styles from './styled';

export const PROPAGATION_DISPLAY = {
  context: 'L',
  global: 'F',
};

export const getPropagationDisplay = (propagation: Propagation): string => {
  return PROPAGATION_DISPLAY[propagation] ?? propagation.replace('step_', 'S');
};

export interface PropagationTagProps extends React.HTMLAttributes<HTMLSpanElement> {
  children?: Propagation;
}

export const PropagationTag = (props: PropagationTagProps) => {
  const { children = 'context', ...p } = props;

  return <Styles.PropagationTag {...p}>{getPropagationDisplay(children)}</Styles.PropagationTag>;
};
